import styles from '../../styles/admin/MainContent.module.scss'
import { CurriculumProps } from '../../types/table'
import Table from '../common/Table'
import VimeoEmbed from '../common/VimeoEnbed'
import CurriculumVideoHeader from './CurriculumVideoHeader'
import CurriculumVideoItem from './CurriculumVideoItem'

export interface VideoDataProps {
  videoID: React.ReactNode
  hash: React.ReactNode
  vimeoId?: string
  hashKey?: string
  title?: string
  videoTitle?: React.ReactNode
}

interface ResultContentProps {
  curriculum: CurriculumProps[]
  videoData: VideoDataProps[]
  showPreview?: boolean
  saveButton?: React.ReactNode
}

const ResultContent = ({
  curriculum,
  videoData,
  showPreview = false,
  saveButton,
}: ResultContentProps) => {
  const previewData = videoData[0]

  return (
    <div
      className={styles.resultContentContainer}
      style={{
        backgroundColor: '#ffff',
        borderRadius: '15px',
        padding: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
      }}
    >
      <h3 className={styles.contentTitle}>Subject</h3>

      <Table className={styles.tableWrapper}>
        <thead>
          <CurriculumVideoHeader />
        </thead>
        <tbody>
          {curriculum.length > 0 ? (
            curriculum.map((curriculumItem, index) => (
              <CurriculumVideoItem
                key={index}
                curriculum={curriculumItem}
                index={index}
              />
            ))
          ) : (
            <tr>
              <Table.Cell colSpan={6}>
                <Table.Empty>No curriculum data available.</Table.Empty>
              </Table.Cell>
            </tr>
          )}
        </tbody>
      </Table>

      <Table className={styles.videoTable}>
        <thead>
          <tr>
            <Table.Header>Video Title</Table.Header>
            <Table.Header>Vimeo ID</Table.Header>
            <Table.Header>Hash Key</Table.Header>
          </tr>
        </thead>

        <tbody>
          {videoData.length > 0 ? (
            videoData.map((video, index) => (
              <tr key={index}>
                <Table.Cell>{video.videoTitle}</Table.Cell>
                <Table.Cell>{video.videoID}</Table.Cell>
                <Table.Cell>{video.hash}</Table.Cell>
              </tr>
            ))
          ) : (
            <tr>
              <Table.Cell colSpan={3}>
                <Table.Empty>No video.</Table.Empty>
              </Table.Cell>
            </tr>
          )}
        </tbody>
      </Table>

      {saveButton}

      {showPreview && previewData && (
        <div
          style={{
            marginTop: '40px',
            padding: '20px',
          }}
        >
          <h3
            style={{
              marginBottom: '20px',
              fontSize: '20px',
              fontWeight: '700',
              color: '#0D2A4F',
            }}
          >
            Video Preview
          </h3>
          <div style={{ width: '100%' }}>
            <VimeoEmbed
              vimeoId={previewData.vimeoId || ''}
              hash={previewData.hashKey || ''}
              title={previewData.title || 'Video Preview'}
            />
          </div>
          {previewData.vimeoId && previewData.hashKey && (
            <div
              style={{
                marginTop: '15px',
                padding: '10px',
                backgroundColor: '#f8f9fa',
                color: '#97a4b4',
              }}
            >
              <strong>미리보기 정보:</strong>
              <br />
              Vimeo ID: {previewData.vimeoId}
              <br />
              Hash Key: {previewData.hashKey}
              <br />
              Title: {previewData.title || 'No Title'}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ResultContent
